import { CampaignBig, CampaignRow } from './blocks/Campaigns';

import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import abonneerImg from '../../assets/images/front-abonneer.webp';
import downloadImg from '../../assets/images/front-download.webp';
import motmImg from '../../assets/images/front-motm.webp';
import espnOne from '../../assets/images/frontpage-espn1.webp';
import leagueIcons from '../../assets/images/frontpage-leagues.svg';
import topVisual from '../../assets/images/frontpage-top-2.webp';
import PageLayout from '../../layouts/PageLayout';
import { pageView } from '../../scripts/analytics';
import Cta from './blocks/Cta/Cta';
import Header from './blocks/Header';

const Frontpage = () => {
    useEffect(() => {
        pageView('espnOne');
    }, []);

    return (
        <PageLayout theme="dark">
            <Helmet>
                <title>ESPN - Kijk alle Eredivisie wedstrijden live!</title>
                <meta
                    name="description"
                    content="Wil je niks meer missen van de Eredivisie? Neem ESPN Compleet en kijk alle wedstrijden live."
                />
                <meta
                    property="og:title"
                    content="ESPN - Kijk alle Eredivisie wedstrijden live!"
                />
                <meta
                    property="og:description"
                    content="Wil je niks meer missen van de Eredivisie? Neem ESPN Compleet en kijk alle wedstrijden live."
                />
                <meta property="og:type" content="website" />
                <meta property="og:image" content={topVisual} />
            </Helmet>
            <Header
                image={topVisual}
                title={
                    <>
                        Voor de fans.
                        <br />
                        Altijd en overal
                    </>
                }
                button={{
                    label: 'Bekijk onze huidige campagnes',
                    link: '#campaigns',
                }}
            />
            <div id="campaigns" />
            <CampaignBig
                id="campaigns"
                title="Mis niks met ESPN Compleet"
                description="Abonneer via je tv provider"
                link="/abonneren"
                image={abonneerImg}
            />
            <CampaignRow
                campaigns={[
                    {
                        title: 'Download de ESPN app',
                        link: '/download',
                        linkLabel: 'Download hier',
                        image: downloadImg,
                    },
                    {
                        title: 'ESPN 1 voor iedereen',
                        link: '/espn1',
                        linkLabel: 'Kijk hier waar ESPN 1 bij jou te zien is',
                        image: espnOne,
                    },
                    {
                        title: 'KPN man of the match',
                        link: 'https://www.espnmanofthematch.nl/#games',
                        linkLabel: 'Stem nu hier',
                        image: motmImg,
                    },
                ]}
            />
            <Cta image={leagueIcons} />
        </PageLayout>
    );
};

export default Frontpage;
